/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ErrorCodeTypes enum represents various error types that can occur in the application.
 *
 * Error codes are categorized into:
 * - Network errors (N6xx): Connection, server, and network-related issues
 * - Service context errors (S6xx): Authentication, authorization, and service-level issues
 * - HTTP errors (G4xx-G6xx): Standard HTTP status code related errors
 */
export enum ErrorCodeTypes {
  // Network errors (N6xx range)
  BAD_RESPONSE = "BAD_RESPONSE",
  CONNECTION_FAILED = "CONNECTION_FAILED",
  CONNECTION_REFUSED = "CONNECTION_REFUSED",
  FILE_NOT_FOUND = "FILE_NOT_FOUND",
  GENERAL = "GENERAL",
  HTTP_BAD_REQUEST = "HTTP_BAD_REQUEST",
  IO = "IO",
  SHORT_RESPONSE = "SHORT_RESPONSE",
  UNKNOWN_SERVER = "UNKNOWN_SERVER",

  // Service context errors (S6xx range)
  BRIDGEKEEPER_CONNECTION_DENIED = "BRIDGEKEEPER_CONNECTION_DENIED",
  CONNECTION_LOST = "CONNECTION_LOST",
  CONTEXT_DESTROYED = "CONTEXT_DESTROYED",
  CREDENTIAL_EXPIRED = "CREDENTIAL_EXPIRED",
  CREDENTIAL_FAILED = "CREDENTIAL_FAILED",
  CREDENTIAL_NOT_AUTHORIZED = "CREDENTIAL_NOT_AUTHORIZED",
  FAILURE_RETRIEVE_DEVICE_LIST = "FAILURE_RETRIEVE_DEVICE_LIST",
  INVALID_ACCESS_TOKEN = "INVALID_ACCESS_TOKEN",
  INVALID_CONTEXT_STATE = "INVALID_CONTEXT_STATE",
  INVALID_RESPONSE = "INVALID_RESPONSE",
  NO_AUTHENTICATE_RESPONSE = "NO_AUTHENTICATE_RESPONSE",
  REQUEST_CONTEXT_ERROR = "REQUEST_CONTEXT_ERROR",
  SCHEMA_EXCEPTION = "SCHEMA_EXCEPTION",
  SERVER_NOT_RESOLVED = "SERVER_NOT_RESOLVED",
  SERVICE_CONTEXT_CONNECTION_FAILED = "SERVICE_CONTEXT_CONNECTION_FAILED",
  SERVICE_CONTEXT_INTERNAL_ERROR = "SERVICE_CONTEXT_INTERNAL_ERROR",
  SERVICE_CONTEXT_MIDDLEMIND_ERROR = "SERVICE_CONTEXT_MIDDLEMIND_ERROR",
  TIMEOUT = "TIMEOUT",

  // HTTP errors (G4xx-G6xx range)
  BAD_GATEWAY = "BAD_GATEWAY",
  BAD_REQUEST = "BAD_REQUEST",
  CONFLICT = "CONFLICT",
  FORBIDDEN = "FORBIDDEN",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  NOT_ALLOWED = "NOT_ALLOWED",
  NOT_AUTHORIZED = "NOT_AUTHORIZED",
  OBJECT_NOT_FOUND = "OBJECT_NOT_FOUND",
  SERVER_TIMEOUT = "SERVER_TIMEOUT",
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
  TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
  UNHANDLED_ERROR = "UNHANDLED_ERROR",
  UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE"
}
